import type { Renderable } from '@adornis/functional-lit/renderable.js';
import { stateful, useObservable } from '@adornis/functional-lit/stateful.js';
import { currentUser } from '@adornis/users/client/currentUser.js';
import { nothing } from 'lit';
import { hasPermission } from '../hasPermission.js';
import type { Permissions, User } from '../permissions.js';

export const permissionGuard = <Resource extends keyof Permissions>({
  resource,
  action,
  data,
  guardedTemplate,
  forbiddenTemplate = nothing,
}: {
  resource: Resource;
  action: Permissions[Resource]['actions'];
  data?: Permissions[Resource]['dataType'];
  guardedTemplate: Renderable;
  forbiddenTemplate?: Renderable;
}) =>
  stateful(() => {
    const user = useObservable(() => currentUser<User>(), []);
    const granted = hasPermission(user, resource, action, data);
    return granted ? guardedTemplate : forbiddenTemplate;
  })();
